
<div>{{header}}</div>

 
<div *ngIf="map != undefined && listsLoaded == true">
  

  <div class="row mappingEdit">

 
  <div class="col-5">
      <div class="form-material">

          <select [ngModel]="map.LectionaryItemType?.Id"  (ngModelChange)="lectionaryItemTypeValueChanged($event)">
             
              <option *ngFor="let section of lectionaryItemTypes" [ngValue]="section.Id">
                  {{section.Localized[0].Name}}
              </option>
            </select>

          <label for="">Lectionary Item Type</label>

      </div>
  </div>  

  <div class="col-4">
    <div class="form-material" [class.disabledOption]="map.LectionaryItemType?.SubTypes?.length == 0"> 
   
          <select *ngIf="map.LectionaryItemType != null" [ngModel]="map.LectionaryItemTypeSubType?.Id" [disabled]="map.LectionaryItemType?.SubTypes?.length == 0" (ngModelChange)="lectionaryItemTypeSubTypeValueChanged($event)">  
              <option *ngFor="let subType of map.LectionaryItemType.SubTypes" [ngValue]="subType.Id">
                  {{subType.Localized[0].Name}}
              </option>
          </select>

          <label for="">Lectionary Item Sub Type</label>
      
    </div>
</div> 

<div class="col-3">
  <div class="form-material">
      <input matInput Xplaceholder="Name" type="number" [(ngModel)]="map.DisplayOrder">
      <label for="">Display Order</label>
  </div>
</div> 



  <div class="col-12">
      <div class="form-material">

          <select name="LectionaryItemName" *ngIf="isLoadingLectionaryItemNames == false" [ngModel]="map.LectionaryItemName?.Id" (ngModelChange)="map.LectionaryItemName = setModelValue($event, map.LectionaryItemName)">
            
            <option *ngFor="let section of lectionaryItemNames" [ngValue]="section.Id">
                {{section.Name}}
              </option>
            </select>

            <div *ngIf="isLoadingLectionaryItemNames == true">
              Loading Lectionary Item Names, one moment please
            </div>
            
          <label for="">Lectionary Item Name</label>

        </div> 
  </div>  
  

    
  <div class="col-6">
      <div class="form-material">

          <select [ngModel]="map.LectionaryYear?.Id"  (ngModelChange)="map.LectionaryYear = setModelValue($event, map.LectionaryYear)">
               
            <option></option>
                <option *ngFor="let section of lectionaryYears" [ngValue]="section.Id">
                  {{section.Localized[0].Name}}
              </option>
            </select>

          <label for="">Lectionary Year</label>

      </div>
  </div>

    
  <div class="col-6" *ngIf="isProper">
      <div class="form-material">

          <select [ngModel]="map.LectionaryTrack?.Id"  (ngModelChange)="map.LectionaryTrack = setModelValue($event, map.LectionaryTrack)">
          

              <option></option>
            <option *ngFor="let section of lectionaryTracks" [ngValue]="section.Id">
                  {{section.Localized[0].Name}}
              </option>
            </select>

          <label for="">Lectionary Track</label>

      </div>
  </div>

 
        
  <div class="col-6">
    <div class="form-material">

        <select [ngModel]="map.LectionarySource?.Id"  (ngModelChange)="map.LectionarySource = setModelValue($event, map.LectionarySource)">
       
          <option *ngFor="let section of lectionarySources" [ngValue]="section.Id">
                {{section.Name}}
            </option>
          </select>

        <label for="">Map Source</label>

    </div>
</div>

  <div class="col-6">
      <div class="form-material">

          <select [ngModel]="map.LiturgyType?.Id"  (ngModelChange)="map.LiturgyType = setModelValue($event, map.LiturgyType)">
               
              <option></option>
              <option *ngFor="let section of liturgyTypes" [ngValue]="section.Id">
                {{section.Localized[0].Name}}
              </option>
            </select>

          <label for="">Liturgy Type</label>

      </div>
  </div>
  
  <div class="col-6">
        <div class="form-material">
            <input matInput Xplaceholder="Name" [(ngModel)]="map.LectionarySourcePageNumber">
            <label for="">Map Page Number</label>
        </div>
    </div> 


    <div class="col-6"> 
            Id: {{map?.Id}}
    </div>



    <div class="col-6" *ngIf="isProper">
        <div class="form-material">
    
            <select [ngModel]="map.Proper?.Id"  (ngModelChange)="map.Proper = setModelValue($event, map.Proper)">
           
              <option *ngFor="let section of propers" [ngValue]="section.Id">
                    Proper Number: {{section.ProperNumber}} Weekday: {{section.Weekday}} 
                </option>
              </select>
    
            <label for="">Proper</label>
    
        </div>
    </div>
    
  <!-- <div class="col-6" *ngIf="isProper">
    <div class="form-material">

        <select [(ngModel)]="map.Proper.ProperNumber"  (XngModelChange)="map.LectionaryTrack = setModelValue($event, map.LectionaryTrack)">   
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option> 
          <option value="4">4</option> 
          <option value="5">5</option> 
          <option value="6">6</option> 
          <option value="7">7</option> 
          <option value="8">8</option> 
          <option value="9">9</option> 
          <option value="10">10</option>  
          <option value="11">11</option>
          <option value="12">12</option>
          <option value="13">13</option> 
          <option value="14">14</option> 
          <option value="15">15</option> 
          <option value="16">16</option> 
          <option value="17">17</option> 
          <option value="18">18</option> 
          <option value="19">19</option> 
          <option value="20">20</option>  
          <option value="21">21</option>
          <option value="22">22</option>
          <option value="23">23</option> 
          <option value="24">24</option> 
          <option value="25">25</option> 
          <option value="26">26</option> 
          <option value="27">27</option> 
          <option value="28">28</option> 
          <option value="29">29</option>  
        </select>

        <label for="">Proper Number</label> 

    </div>
  </div>
 
  <div class="col-6">
    <div class="form-material">

      <select [ngModel]="map.Proper.Weekday"  (XngModelChange)="map.LectionarySource = setModelValue($event, map.LectionarySource)">
      
          <option value="1">1</option>
          <option value="2">2</option>
          <option value="3">3</option> 
          <option value="4">4</option>
          <option value="5">5</option>
          <option value="6">6</option> 
          <option value="7">7</option> 

      </select>

      <label for="">Proper Weekday</label>

    </div>
  </div> -->




  </div>

  <div class="row">

    <div class="col-sm-12 text-right buttonBar">
        <button mat-button (click)="cancel()" class="btn btn-sm btn-outline-secondary">Cancel</button>
        <button mat-button (click)="save()" class="btn btn-sm btn-outline-primary">Save Map</button> 
    </div>

</div>

</div>

<app-progress-bar *ngIf="listsLoaded==false"></app-progress-bar>